<template>
  <div class="custom-dropdown">
    <div class="dropdown-header" @click="toggleDropdown">
      {{ selectedOption || $t("language") }}
    </div>
    <div class="dropdown-options" v-show="isOpen">
      <div
        class="dropdown-option"
        v-for="(option, index) in options"
        :key="index"
        @click="selectOption(option)"
      >
        {{ option }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false,
      selectedOption: "",
      options: ["English", "اُردُو"],
    }
  },
  mounted() {
    // Initialize from current locale
    const current = this.$i18n && this.$i18n.locale
    this.selectedOption = current === "ur" ? "اُردُو" : "English"
  },
  watch: {
    "$i18n.locale"(val) {
      this.selectedOption = val === "ur" ? "اُردُو" : "English"
    },
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen
    },
    selectOption(option) {
      this.selectedOption = option
      this.isOpen = false
      this.$emit("selected", option) // 可选：触发事件通知父组件
    },
  },
}
</script>

<style scoped>
.custom-dropdown {
  padding: 0px 20px;
  position: relative;
  width: 100px;
  margin-left: 2rem;
  font-family: Arial, sans-serif;
  color: #000;
  cursor: pointer;
}

.dropdown-header {
  /* background-color: red; */
  /* padding: 10px; */
  /* padding: .625rem; */

  color: #fff;

  font-size: 1.375rem;
  height: 3.3125rem;

  text-align: center;
  line-height: 3.3125rem;
  /* background-color: #f9f9f9; */
}

.arrow {
  transition: transform 0.3s;
}

.arrow-up {
  transform: rotate(180deg);
}

.dropdown-options {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  border: 1px solid #ccc;
  border-top: none;
  border-radius: 0 0 4px 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  background-color: white;
  width: 100px;
}

.dropdown-option {
  padding: 10px;
  cursor: pointer;
  font-size: 1rem;
}

.dropdown-option:hover {
  background-color: #f0f0f0;
}
@media screen and (max-width: 1000px) {
  .custom-dropdown {
    padding: 3px;
    display: flex;
    justify-content: center;
    position: relative;
    width: 100px;
    background-color: #2a3f93;
    border-radius: 20px;
  }

  .dropdown-header {
    color: #fff;
    font-size: 1.375rem;
    text-align: center;
  }

  .dropdown-option {
    padding: 10px;
    cursor: pointer;
    font-size: 1.5rem;
  }
}
</style>
